// @core/api/endpoints/team/create_role_schedule.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateRoleScheduleRequest,
  RoleScheduleResponse,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Create role schedule
 * Creates a new role schedule with the provided data. Returns the created resource.
 */
export async function CreateRoleSchedule(
  team_id: string,
  data: CreateRoleScheduleRequest,
  options?: RequestOptions
): Promise<RoleScheduleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/schedules`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.post<RoleScheduleResponse>(requestPath, data, requestOptions);
}
